import React, {useEffect, useState} from "react";
import {DatePicker, Form, Input, Select} from "antd";
import {Button} from "evergreen-ui";
import FireFetch from "../../FireFetch";
import {MDBAlert} from "mdbreact";
import Firebase from "../../../Firebase";
import {useListVals} from "react-firebase-hooks/database";
import {useCollection} from "react-firebase-hooks/firestore";


const dbRef = Firebase.database().ref('System/Users');
const outletRef = Firebase.database().ref('System/Outlets');
const db = Firebase.firestore();
const moment = require("moment");
const {TextArea} = Input;
const EditTaskModal = (props) => {

    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [outlets] = useCollection(
        db.collection('outlets'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [userArray, setUserArray] = useState([]);
    const [outletArray, setOutletArray] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [color, setColor] = useState("info");
    const [message, setMessage] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [showBrand, setShowBrand] = useState(false);
    const [deadline, setDeadline] = useState(null);
    const [location, setLocation] = useState(null);
    const [task, setTask] = useState(props.selectedTask);

    useEffect(() => {
        if(props.selectedTask.taskType === "Brand Coverage"){
            setShowBrand(true);
        } else {
            setShowBrand(false);
        }
        setTask(props.selectedTask);

        if(users){
            var tempUseArray = [];
            users.docs.map((item) => {
                var user = item.data();
                tempUseArray.push(user);
            })
            //var filteredArray = tempUseArray.filter(x => x.role === "SalesRep");
            setUserArray([...tempUseArray]);
        }

        if(outlets){
            var tempArray = [];
            outlets.docs.map((item) => {
                var outlet = item.data();
                tempArray.push(outlet);
            });
            setOutletArray([...tempArray]);
        }


        }, [outlets, props, showBrand, users])


    function changeType (selectedOption) {
        if(selectedOption === "Brand Coverage"){
            setShowBrand(true);
        } else {
            setShowBrand(false);
        }
    }

    function changeDate(date, dateString) {
        setDeadline(dateString);
    }


    const editTask = (values) => {
        //setShowLoading(true);

        var date = values.deadline;
        console.log(date.format("YYYY-MM-DDTh:mm"));

        var object = {
            title : values.title,
            description : values.description,
            deadline : values.deadline.format("YYYY-MM-DDTh:mm"),
            assignedUser : values.assigned,
            taskStatus : values.status,
            taskType : values.type
        }

        if(showBrand){
            object.location = values.location;
        } else {
            object.assignedOutlet = values.outlet;
        }

        console.log(object);


        const output = FireFetch.updateInDB("Tasks", task.taskID, object);
        output.then((result) => {
            console.log(result);
            if(result === "success"){
                setMessage("Task edited successfully");
                setColor("success");
                setShowAlert(true);
                setShowLoading(false);
                setTimeout(() => {
                    setShowAlert(false);
                    props.modal(false);
                }, 2000);

            }
        }).catch((error) => {
            setMessage("Unable to edit task, an error occurred :: " + error);
            setColor("danger");
            setShowAlert(true);
            setShowLoading(false);
        });

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div>
            <Form
                layout="vertical"
                onFinish={editTask}
                onFinishFailed={onFinishFailed}
                initialValues={{
                    type : task.taskType,
                    location : task.location,
                    outlet : task.location,
                    assigned : task.assignedUser,
                    status : task.taskStatus,
                    title : task.title,
                    description: task.description,
                    deadline : !task.deadline ? undefined : moment(task.deadline, "YYYY-MM-DD h:mm"),


                }}
            >
                <Form.Item label="Title"
                           name="title"
                           rules={[{ required: showBrand, message: 'Please input task title!' }]}>
                    <Input type="text" placeholder="enter task title" id="title"/>
                </Form.Item>
                <Form.Item label="Description"
                           name="description"
                           rules={[{ required: showBrand, message: 'Please input description!' }]}>
                    <TextArea type="text" placeholder="enter task description"
                              aria-multiline={true} id="description"/>
                </Form.Item>

                <Form.Item label="Task Type"
                           name="type">
                    <Select placeholder="Select task type"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                            onChange={changeType}>
                        {["Normal", "Brand Coverage"].map((item, index) => (
                            <Select.Option key={index}  value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>

                {showBrand ?
                    <Form.Item label="Coverage Location"
                               name="location">
                        <Input type="text" value={showBrand&&location}
                               placeholder="enter coverage location"
                               onChange={e => setLocation(e.target.value)} id="location"/>
                    </Form.Item>
                    :
                    <Form.Item label="Outlet Assigned"
                               name="outlet">
                        <Select placeholder="Select assigned outlet"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }>
                            {outletArray.map((item, index) => (
                                <Select.Option key={index}  value={item.outletID}>{item.name}</Select.Option>
                            ))}

                        </Select>
                    </Form.Item>
                }


                <Form.Item label="Assigned To"
                           name="assigned">
                    <Select placeholder="Select assigned user"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }>
                        {userArray.map((item, index) => (
                            <Select.Option key={index}  value={item.userID}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>

                <Form.Item label="Task Status"
                           name="status">
                    <Select placeholder="Select task status"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }>
                        {["Incomplete", "Complete", "Pending Further Info"].map((item, index) => (
                            <Select.Option key={index}  value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>

                <Form.Item
                    label="Select Task Deadline"
                    name="deadline">
                    <DatePicker
                        placeholder="select deadline date"
                        showTime={{ format: 'HH:mm' }}
                        picker={"date"}
                        className="w-100"
                        onChange={changeDate} />

                </Form.Item>


                {showAlert?
                    <>
                        <MDBAlert color={color} className="my-3 font-italic" >
                            {message}
                        </MDBAlert>
                    </>
                    : null }

                <Button appearance="primary" htmlType="submit" isLoading={showLoading}>
                    Edit
                </Button>

            </Form>

        </div>
    )

}

export default EditTaskModal;
